<div class="merchant-detail">
  <nav class="merchant-detail-tabs">
    <span class="merchant-detail-name" *ngIf="merchantName" data-cy="merchant-detail-name">{{ merchantName }}</span>
    <a
      *ngFor="let tab of tabs"
      class="merchant-detail-tab"
      [routerLink]="tab.path"
      routerLinkActive="active"
      data-cy="merchant-detail-tab"
      >{{ tab.label }}</a
    >
  </nav>
  <div class="merchant-detail-content">
    <router-outlet></router-outlet>
  </div>
</div>
